
import axios from 'axios'
import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Options } from '../../Components/components'
import { SongContext } from '../../Routes/Routes1'
import './play-song.css'


function getParentPath(path){
    let parentId=""
    let i=1
    while(path[i] !== "/"){
        parentId+=path[i]
        i++
    }
    return parentId
}

export default function PlaySong(){
    const [isLoading,setLoading]=useState(false)
    const {songs,setSong}=useContext(SongContext)

    const id=useParams()
    const path=window.location.pathname
    const PORT=process.env.REACT_APP_URL_PORT
    useEffect(()=>{
        axios.post(`https://${PORT}/admin/song_search`,{
            id:id.id,
            sType:getParentPath(path)
        })
        .then(res=>{
            setLoading(true)
            setSong(res.data)
        })
        .catch(console.log("Not found!!!"))
    },[id.id,path,setSong,PORT])

    return (
        <div className="row mtmd">
            <div className="col-12">
                <div className="row container">
                    {
                        !isLoading?
                        <div>Loading...</div>:
                        <>
                            <div className="col-md-6 col-sm-7 col-12">
                                <img id="pimg" src={songs.sImage} alt="..."/>
                            </div>
                            <div className="col-md-6 col-sm-5 col-12 mt-5">{songs.sName}
                                <div className="mts">{songs.maName}
                                    <Options songData={songs}/>
                                </div>
                            </div>
                        </>
                    }
                    
                </div>
            </div>
        </div>
    )
} 